<div
  class="eurostar-card"
  [ngClass]="policyClass"
  [class.eurostar-card--expanded]="isExpanded"
  role="button"
  [attr.tabindex]="isBlocked ? -1 : 0"
  [attr.aria-disabled]="isBlocked ? true : null"
  [attr.aria-expanded]="isExpanded"
  [attr.aria-label]="fareOptionsLabel + ' ' + from + ' to ' + to"
  (click)="toggleExpand()"
  (keydown)="onKey($event)"
>
  @if (policyLabel) {
    <span class="visuallyhidden">{{ policyLabel }}</span>
  }
  <div class="eurostar-card__body">
    <div class="eurostar-card__main">
      @if (departDate) {
        <div class="eurostar-card__date">{{ departDate }}</div>
      }

      <div class="eurostar-card__times">
        <span class="eurostar-card__time">{{ card.timeDeparture }}</span>
        <span class="eurostar-card__arrow">→</span>
        <span class="eurostar-card__time">{{ card.timeArrival }}</span>
      </div>

      @if (from || to) {
        <div class="eurostar-card__route">{{ from }} → {{ to }}</div>
      }

      <div class="eurostar-card__meta">
        @if (card.duration) {
          <span class="eurostar-card__duration">{{ card.duration }}</span>
          <span class="eurostar-card__separator">·</span>
        }
        <span class="eurostar-card__changes" i18n="@@chatEurostarDirect">Direct</span>
      </div>
    </div>

    <div class="eurostar-card__price-col">
      @if (cheapestFare) {
        <span class="eurostar-card__price-label" i18n="@@chatEurostarTotalPrice">Total Price</span>
        <span class="eurostar-card__price">
          {{ formatPrice(cheapestFare.price, cheapestFare.currency) }}
        </span>
        <fa-icon
          class="eurostar-card__chevron"
          [icon]="isExpanded ? faChevronUp : faChevronDown"
        ></fa-icon>
        <!-- Policy indicator: same component/tooltip as the results page,
             placed under the headline fare per the travel-policy spec. -->
        <app-warning-tags
          [ticket]="headlineWarningTicket"
          [displayCheck]="false"
          (click)="$event.stopPropagation()"
        ></app-warning-tags>
      } @else {
        <span class="eurostar-card__unavailable" i18n="@@chatEurostarUnavailable">Unavailable</span>
      }
    </div>
  </div>

  <!-- Fare breakdown panel, shown on expand -->
  @if (isExpanded && card.fares?.length) {
    <div class="eurostar-card__fares" (click)="$event.stopPropagation()">
      <div class="eurostar-card__fares-title" i18n="@@chatEurostarAvailableFares">
        Available fares
      </div>
      @for (fare of card.fares; track fare.class) {
        <div
          class="eurostar-card__fare-row"
          [class.eurostar-card__fare-row--unavailable]="fare.unavailable"
        >
          <span class="eurostar-card__fare-class">{{ fare.class }}</span>
          <app-warning-tags
            [ticket]="warningTicketFor(fare)"
            [displayCheck]="false"
            (click)="$event.stopPropagation()"
          ></app-warning-tags>
          <button
            type="button"
            class="eurostar-card__fare-price eurostar-card__fare-price--link"
            [disabled]="fare.unavailable"
            (click)="onSelectFare(fare, $event)"
          >
            {{ formatPrice(fare.price, fare.currency) }}
          </button>
        </div>
      }

      @if (card.co2PerPassenger > 0) {
        <div class="eurostar-card__co2">
          <span i18n="@@chatEurostarCo2">CO₂: </span>
          <span>{{ card.co2PerPassenger | number: '1.1-1' }} kg</span>
        </div>
      }
    </div>
  }
</div>
